var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"application"}},[_c('gtr-loader',{attrs:{"value":_vm.loader.value,"size":_vm.loader.size,"index":_vm.loader.index}}),_c('v-app',[_c('v-main',[_c(_vm.layout,{tag:"component"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$router.path})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }